import { deepPurple, red, orange, green } from '@material-ui/core/colors';
import { SCHEDULES } from '../store/route-page';

const { SCHEDULE_0830, SCHEDULE_1000, SCHEDULE_1400, SCHEDULE_2400 } = SCHEDULES;

export const orderedColors = {
  [SCHEDULE_0830]: deepPurple[800],
  [SCHEDULE_1000]: red[800],
  [SCHEDULE_1400]: orange[800],
  [SCHEDULE_2400]: green[800],
};

export const unorderedColors = {
  [SCHEDULE_0830]: deepPurple[400],
  [SCHEDULE_1000]: red[400],
  [SCHEDULE_1400]: orange[400],
  [SCHEDULE_2400]: green[400],
};



// WEBPACK FOOTER //
// ./src/helpers/schedules-colors.js